import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useRef, useState } from 'react';
import { debounce } from 'lodash';
export type ElementSize = {
  width: number;
  height: number;
};
type UseResizeObserverOptions = {
  debounceMs?: number;
};
export function useGetElementSize(t0) {
  const $ = _c(10);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const {
    debounceMs: t2
  } = options;
  const debounceMs = t2 === undefined ? 100 : t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: 0,
      height: 0
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [size, setSize] = useState(t3);
  const observer = useRef(null);
  let t4;
  if ($[3] !== debounceMs) {
    t4 = debounce(setSize, debounceMs);
    $[3] = debounceMs;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const debouncedSetSize = t4;
  let t5;
  if ($[5] !== debouncedSetSize) {
    t5 = node => {
      if (observer.current) {
        observer.current.disconnect();
        debouncedSetSize.cancel();
      }
      observer.current = new ResizeObserver(entries => {
        const entry = entries[0];
        if (entry) {
          const {
            width,
            height
          } = entry.contentRect;
          debouncedSetSize({
            width,
            height
          });
        }
      });
      if (node) {
        observer.current.observe(node);
      }
    };
    $[5] = debouncedSetSize;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const ref = t5;
  let t6;
  if ($[7] !== ref || $[8] !== size) {
    t6 = {
      ref,
      size
    };
    $[7] = ref;
    $[8] = size;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}